function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDoneSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.82 109.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.83,109.66a54.83,54.83,0,1,1,54.83-54.83A54.89,54.89,0,0,1,54.83,109.66Zm0-102.35a47.52,47.52,0,1,0,47.52,47.52A47.58,47.58,0,0,0,54.83,7.31Z",
    style: {
      fill: "#22bb33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.76,79.64a5.6,5.6,0,0,1-4-1.64L24.58,51.78a5.59,5.59,0,0,1,7.91-7.91L54.76,66.13,119.27,1.64a5.59,5.59,0,0,1,7.91,7.91L58.71,78A5.57,5.57,0,0,1,54.76,79.64Z",
    style: {
      fill: "#22bb33"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoneSuccess);
export default __webpack_public_path__ + "static/media/check-done-success.3cb8820bfa5635a0739f61d8efd60a08.svg";
export { ForwardRef as ReactComponent };